import {
  PermissionAction,
  PermissionScope,
  PermissionTableDataType,
} from 'dashboard/components/PermissionsTable/constants';
import { Permission } from 'lib/permissions';

export const AdminSectionData: PermissionTableDataType = {
  sections: [
    {
      label: 'Users',
      tooltip:
        'Allows this role to manage users, assign user roles, and update other settings for users',
      subSections: [
        {
          scopes: [],
          rows: [
            {
              label: 'Users',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.UserView, scopes: [] }],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    { permission: Permission.UserWrite, scopes: [] },
                    { permission: Permission.UserAvailabilityAllUsersWrite, scopes: [] },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'Roles',
      tooltip: 'Allows this role to view and edit all user roles and permissions',
      subSections: [
        {
          scopes: [],
          rows: [
            {
              label: 'Roles',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.RoleView, scopes: [] }],
                },
              ],
            },
          ],
        },
        {
          scopes: [],
          rows: [
            {
              label: 'Assign user',
              tooltip: 'Allows this role to add and remove users in non-admin roles',
              actions: [
                {
                  label: PermissionAction.Edit,
                  permissions: [{ permission: Permission.RoleAssignUser, scopes: [] }],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'Teams',
      tooltip: 'Allows this role to view and update team members',
      subSections: [
        {
          scopes: [PermissionScope.Team],
          rows: [
            {
              label: 'Teams',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    { permission: Permission.TeamView, scopes: [PermissionScope.Team] },
                  ],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.TeamWrite,
                      scopes: [PermissionScope.Team],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'Organization',
      subSections: [
        {
          scopes: [],
          rows: [
            {
              label: 'Information',
              tooltip:
                'Allows this role to view and edit details about the organization, including security settings',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.OrganizationView, scopes: [] }],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.OrganizationWrite,
                      scopes: [],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Billing',
              tooltip: 'Allows this role to view all invoices and update the payment method',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    { permission: Permission.InvoiceList, scopes: [] },
                    { permission: Permission.InvoiceView, scopes: [] },
                  ],
                },
              ],
            },
            {
              label: 'User Sessions',
              tooltip:
                'Allows this role to view all user sessions and sign out users from existing sessions',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.UserSessionsAllUsersView, scopes: [] }],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.UserSessionsWrite,
                      scopes: [],
                    },
                  ],
                },
              ],
            },
            {
              label: 'User Audit Logs',
              tooltip: 'Allows this role to view user audit logs',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.UserAuditLogsAllUsersView, scopes: [] }],
                },
              ],
            },
            {
              label: 'View MFA settings',
              tooltip: 'Allows this role to view MFA settings for all users',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [{ permission: Permission.UserMfaAllUsersView, scopes: [] }],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
